<template>
    <div id="modal-selecionar-empresa">
        <b-modal v-if="modalShow" id="selecionar-empresa-beneficiarios-import" centered body-class="selecionar-empresa-beneficiarios-import-body px-3" 
        no-stacking hide-footer @hidden="_closeModal" :visible="true">
            <template #modal-header>
                <div>
                    <div class="modal-title-flex">
                        <div class="modal-title-content">
                            <DynamicIcon icon="company" classString="container-title-icon"/>
                            <span class="modal-title-text">Selecionar Empresa</span>  
                        </div>
                        <div @click="_closeModal">
                            <DynamicIcon icon="delete" :classString="'alert-exclamation-40'"/>
                        </div>
                    </div>
                    
                    <p class="modal-header-p">
                        Encontramos mais de um empresa vinculada ao seu cadastro. Por favor, selecione a que deseja utilizar.
                    </p>
                </div>
            </template>	

            <div class="row w-100 m-0 mt-2">
                <div class="col-12 p-0" v-for="(item, key) in empresaOptions" :key="key">
                    <a id="item" @click="selectItem(item.id)">
                        <div class="select-empresa-box p-3 mb-2 optum-bold">
                            {{ item.text }}
                        </div>
                    </a>
                </div>
            </div>	
        </b-modal>
    </div>
</template>
<script>
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
export default {
	name: "ModalSelecionarEmpresaBeneficiario",
    components:{
		DynamicIcon
	},
    props:{
        closeModal: Boolean
    },
    data() {
        return {
            modalShow: false,
            empresa: null,
            empresaOptions: [{id:0,text: "Atlassian"},{id:1,text: "Atlassian"}],
            redirect: true
        }
    },
    methods : {
        selectItem(id) {
           this.empresa = this.empresaOptions.find(elem => elem.id == id)            
            this.$emit("update-empresa", this.empresa)
            this.modalShow = false
        },
        _closeModal() {
            if(this.empresa == null)
                this.$router.replace({path: '/master-page'})

            this.$emit('close')
        },
    },
    mounted() {
		UserResource.empresa(null,{ showLoader: false}).then(result => {
			if(Array.isArray(result))
			{
                this.empresaOptions = result
				if(result.length == 1)
				{
					this.selectItem(result[0].id)
                    return;
				}
                this.modalShow = true                
            }
		})
	}
}
</script>
<style>
a#item {
    color: inherit; 
    text-decoration: inherit; 
}
.modal-content {
    width: 90% !important;
}
.modal-title-flex {
    width: 100% !important;
    display: flex;
    justify-content: space-between ;
    align-items: center;
    margin-bottom: 4%;
}
.modal-title-content {
    display: flex;
    justify-content: flex-start ;
    align-items: center;
    gap: 17px;
}

.modal-title-text {
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-size: 24px;
    color: rgb(0, 38, 119);
    text-align: left;
}

.modal-header-p {
    margin: 0px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    font-size: 16px;
    color: rgb(90, 90, 90);
}

.select-empresa-box {
    text-align: left;
    border-radius: 16px;
    border: 2px solid rgb(209, 209, 209);
    background-color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 700;
}

.select-empresa-box:hover {
    border-color: rgb(0, 38, 119);
    background-color: rgb(217, 246, 250);;
}
</style>